import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const create = gql`
  mutation CreateBusinessMutation($name: String!, $imageUrl: String, $onboardingSlug: String) {
    createBusiness(
      input: {
        business: { name: $name, img: $imageUrl }
        onboardingExperiencesWhitelist: [$onboardingSlug]
      }
    ) {
      business {
        ...Business
      }
    }
  }
  ${Fragments.business.business}
`;

export const update = gql`
  mutation UpdateBusinessMutation($businessId: Int!, $name: String!, $imageUrl: String) {
    updateBusiness(input: { id: $businessId, name: $name, img: $imageUrl }) {
      business {
        ...Business
      }
    }
  }
  ${Fragments.business.business}
`;

export const removeUsers = gql`
  mutation RemoveUsersFromBusinessMutation($input: RemoveUsersFromBusinessInput!) {
    removeUsersFromBusiness(input: $input) {
      success
      userIds
    }
  }
`;

export const readdUsers = gql`
  mutation ReaddUsersToBusinessMutation($businessId: Int!, $userIds: [Int]!) {
    businesses {
      readdUsers(businessId: $businessId, userIds: $userIds) {
        business {
          id
        }
      }
    }
  }
`;

export const inviteUsers = gql`
  mutation InviteUsersToBusinessMutation($businessId: Int!, $users: [NewUser!]!) {
    createUsers(input: { businessId: $businessId, users: $users }) {
      users {
        id
      }
      existingUsers {
        id
      }
    }
  }
`;

export const selectPurpose = gql`
  mutation SelectBusienssPurposeMutation($businessId: Int!, $purposes: [NewPurpose!]!) {
    updateBusinessPurpose(input: { businessId: $businessId, purposes: $purposes }) {
      success
    }
  }
`;

export const createMedia = gql`
  mutation CreateMediaMutation($input: CreateMedia!) {
    createMedia(input: $input) {
      fileName
      mimeType
      presignedPost {
        url
        fields
      }
    }
  }
`;
